/** Supported marketplace display currencies (base price stored as INR). */
export const SUPPORTED_CURRENCIES = [
  "INR",
  "USD",
  "GBP",
  "CAD",
  "AUD",
  "EUR",
  "CHF",
  "SEK",
  "NOK",
  "DKK",
  "SGD",
];

/** Country ISO-2 → supported currency. Unsupported countries fall back to USD. */
export const COUNTRY_TO_CURRENCY = {
  IN: "INR",
  US: "USD",
  GB: "GBP",
  CA: "CAD",
  AU: "AUD",
  DE: "EUR",
  FR: "EUR",
  NL: "EUR",
  ES: "EUR",
  IT: "EUR",
  IE: "EUR",
  AT: "EUR",
  BE: "EUR",
  PT: "EUR",
  FI: "EUR",
  GR: "EUR",
  LU: "EUR",
  CH: "CHF",
  SE: "SEK",
  NO: "NOK",
  DK: "DKK",
  SG: "SGD",
};

export const DEFAULT_CURRENCY = "USD";
export const BASE_CURRENCY = "INR";

export const CURRENCY_STORAGE_KEY = "currencyOverride";
export const LEGACY_CURRENCY_STORAGE_KEY = "selectedCurrency";

export const FALLBACK_RATES_FROM_INR = {
  INR: 1,
  USD: 0.0115,
  GBP: 0.0089,
  CAD: 0.0157,
  AUD: 0.0176,
  EUR: 0.0105,
  CHF: 0.01,
  SEK: 0.12,
  NOK: 0.122,
  DKK: 0.078,
  SGD: 0.0153,
};

export function isSupportedCurrency(code) {
  return SUPPORTED_CURRENCIES.includes(String(code || "").toUpperCase());
}

export function normalizeCurrency(code, fallback = DEFAULT_CURRENCY) {
  const cur = String(code || "").toUpperCase();
  return isSupportedCurrency(cur) ? cur : fallback;
}

export function countryToCurrency(countryCode) {
  if (!countryCode) return DEFAULT_CURRENCY;
  const mapped = COUNTRY_TO_CURRENCY[String(countryCode).toUpperCase()];
  return mapped || DEFAULT_CURRENCY;
}
